import { actionTypes } from '../actions/actionTypes/projectManagementActionTypes';

let initialState = {
  MyDraftProjectInfo: {},
  MyProjectCaseInfo: {},
  MyPortfolioCaseInfo: {},
  MyResourceNeedCaseInfo: {},
  GetProjectInfoLoader: false,
  NewProjectInfo: {},
  NewProjectInfoLoader: false,
  SaveOrCreateProjectLoader: false,
  saveOrCreateProjectData: {},
  SaveOrCreateInvoiceLoader: false,
  saveOrCreateInvoiceData: {},
  isInvoiceSavedSuccessfully: false,
  invoiceResources: [],
  invoiceDate: '',
  dueDate: '',
  invoicePeriodStartDate: '',
  invoicePeriodEndDate: '',
  weekNumber: '',
  invoiceMonth: '',
  billingMonth: '',
  noOfDays: '',
  projectedInvoiceAmount: 0,
  getResourcesLoader: false,
  invoiceCaseDetails: {},
  openInvoiceCaseLoader: false,
  invoiceDetailsData: {},
  getInvoiceDetailsLoader: false,
  voidInvoiceLoader: false,
  openPMCaseLoader: false,
  PMCaseData: {},
  ClientAttachments: [],
  isProjectSavedSuccessfully: false,
  isCaseWithdrawnSuccessfully: false,
  GoToHome: false,
  pagination: 0,
  GetMyProjectCasesLoader: false,
  ProjectCases: [],
  ApproveOrRejectPMcaseLoader: false,
  CreateResourceInfoLoader: false,
  Roleslist: [],
  SkillsList: [],
  CreateResourceNeedCaseLoader: false,
  Commentslist: [],
  withdrawCaseLoader: false,
  ResourceNeedInfo: {},
  WithdrawReason: '',
  HoldAndReserveLoader: false,
  holdedResources: [],
  reservedResources: [],
  allocatedResources: [],
  tabIndex: 0,
  ResourceNeedCaseInfo: {},
  SwapResourceCaseInfo: {},
  RNCaseLoader: false,

  SwapCaseDetails: {},
  SwapCaseDetailsLoader: false,

  SearchEmpPMLoader: false,
  ActiveEmployeeList: [],
  ProjectMaintenanceOptionMenu: [],
  closeProjectLoader: false,
  isClickedOnApply: false,
  ApplyEndDateLoader: false,

  submitProjectUpdateLoader: false,
  allocations: [],
  currentProjectAllocationLoader: false,
  showskillLoader: false,
  HasCaseForPortfolioManager: false,
  IsEligibleForAction: false,
  ClientDetails: [],
  ClientNamesList: [],
  ClientCases: [],
  CountryList: [],
  PaymentTermList: [],
  HCMOrg: '',
  LoginUserID: '',
  auditHistory: [],
  auditHistoryLoader: false,
};

/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function ProjectManagement(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PROJECTMANAGEMENT_SUCCESS:
      return {
        ...state,
        GetProjectInfoLoader: false,
        HasCaseForPortfolioManager:
          action.data?.HasCaseForPortfolioManager === 'true' ? true : false || false,
        MyDraftProjectInfo: action.data?.MyDraftProjectInfo || {},
        MyProjectCaseInfo: action.data?.MyProjectCaseInfo || {},
        MyPortfolioCaseInfo: action.data?.MyPortfolioCaseInfo || {},
        MyResourceNeedCaseInfo: action.data?.MyResourceNeedCaseInfo || {},
        ClientDetails: action.data?.ClientDetails || [],
        ClientNamesList: action.data?.ClientNamesList || [],
        ClientCases: action.data?.ClientCases || [],
        CountryList: action.data?.CountryList || [],
        PaymentTermList: action.data?.PaymentTermList || [],
        HCMOrg: action.data?.HCMOrg || '',
        LoginUserID: action.data?.LoginUserID || '',
        ClientAttachments: [],
        auditHistory: [],
        GoToHome: false,
      };
    case actionTypes.GET_PROJECTMANAGEMENT_FAILURE:
      return {
        ...state,
        GetProjectInfoLoader: false,
        GoToHome: false,
      };
    case actionTypes.GET_PROJECTMANAGEMENT_LOADER:
      return {
        ...state,
        GetProjectInfoLoader: true,
      };

    case actionTypes.CREATE_PROJECTMANAGEMENT_INFO_SUCCESS:
      return {
        ...state,
        NewProjectInfoLoader: false,
        NewProjectInfo: {
          ...(action.data.ProjectInfo || {}),
          PaymentTermList:
            action.data?.PaymentTermList || action.data?.ProjectInfo?.PaymentTermList || [],
        },
      };
    case actionTypes.CREATE_PROJECTMANAGEMENT_INFO_FAILURE:
      return {
        ...state,
        NewProjectInfoLoader: false,
      };
    case actionTypes.CREATE_PROJECTMANAGEMENT_INFO_LOADER:
      return {
        ...state,
        NewProjectInfoLoader: true,
      };

    case actionTypes.SAVEORCREATE_PROJECT_SUCCESS:
      return {
        ...state,
        SaveOrCreateProjectLoader: false,
        saveOrCreateProjectData: action.data || {},
        // NewProjectInfo: action.data.ProjectInfo || {},
        isProjectSavedSuccessfully: action?.data?.ProjectInfo?.pyErrorPage?.pyRawMessage
          ? false
          : true,
      };
    case actionTypes.SAVEORCREATE_PROJECT_FAILURE:
      return {
        ...state,
        SaveOrCreateProjectLoader: false,
        isProjectSavedSuccessfully: false,
      };
    case actionTypes.SAVEORCREATE_PROJECT_LOADER:
      return {
        ...state,
        SaveOrCreateProjectLoader: true,
        isProjectSavedSuccessfully: false,
      };

    case actionTypes.SAVEORCREATE_INVOICE_SUCCESS:
      return {
        ...state,
        SaveOrCreateInvoiceLoader: false,
        saveOrCreateInvoiceData: action.data || {},
        isInvoiceSavedSuccessfully: action?.data?.ProjectInfo?.pyErrorPage?.pyRawMessage
          ? false
          : true,
      };
    case actionTypes.SAVEORCREATE_INVOICE_FAILURE:
      return {
        ...state,
        SaveOrCreateInvoiceLoader: false,
        isInvoiceSavedSuccessfully: false,
      };
    case actionTypes.SAVEORCREATE_INVOICE_LOADER:
      return {
        ...state,
        SaveOrCreateInvoiceLoader: true,
        isInvoiceSavedSuccessfully: false,
      };

    case actionTypes.GET_RESOURCES_PM_SUCCESS:
      return {
        ...state,
        invoiceResources: action.data?.InvoiceResourceList || [],
        invoiceDate: action.data?.InvoiceDate || '',
        dueDate: action.data?.DueDate || '',
        invoicePeriodStartDate: action.data?.InvoicePeriodStartDate || '',
        invoicePeriodEndDate: action.data?.InvoicePeriodEndDate || '',
        weekNumber: action.data?.WeekNumber || '',
        invoiceMonth: action.data?.MonthName || '',
        billingMonth: action.data?.BillingMonth || '',
        noOfDays: action.data?.NoOfDays || '',
        projectedInvoiceAmount: action.data?.ProjectedInvoiceAmount || 0,
        getResourcesLoader: false,
      };
    case actionTypes.GET_RESOURCES_PM_FAILURE:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
        getResourcesLoader: false,
      };
    case actionTypes.GET_RESOURCES_PM_LOADER:
      return {
        ...state,
        getResourcesLoader: true,
      };

    // Response shape isn't guaranteed to nest under ProjectInfo (some PM case
    // endpoints return it flat, like GET_RESOURCES_PM_SUCCESS above) — read
    // defensively so either shape populates the view.
    case actionTypes.OPEN_INVOICE_CASE_SUCCESS: {
      // IsInvoiceReadOnly rides as a sibling of ProjectInfo, not inside it —
      // fold it in explicitly so it isn't dropped when the nested shape wins.
      const invoiceCase = action.data?.ProjectInfo
        ? { ...action.data.ProjectInfo, IsInvoiceReadOnly: action.data.IsInvoiceReadOnly }
        : action.data || {};
      return {
        ...state,
        invoiceCaseDetails: invoiceCase,
        invoiceResources: invoiceCase.InvoiceResourceList || [],
        invoiceDate: invoiceCase.InvoiceDate || '',
        dueDate: invoiceCase.DueDate || '',
        invoicePeriodStartDate: invoiceCase.InvoicePeriodStartDate || '',
        invoicePeriodEndDate: invoiceCase.InvoicePeriodEndDate || '',
        weekNumber: invoiceCase.WeekNumber || '',
        invoiceMonth: invoiceCase.Invoicemonth || '',
        billingMonth: invoiceCase.BillingMonth || '',
        noOfDays: invoiceCase.NoOfDays || '',
        projectedInvoiceAmount:
          invoiceCase.ProjectedInvoiceAmount || invoiceCase.CalculatedInvoiceAmount || 0,
        openInvoiceCaseLoader: false,
      };
    }
    case actionTypes.OPEN_INVOICE_CASE_FAILURE:
      return {
        ...state,
        invoiceCaseDetails: {},
        openInvoiceCaseLoader: false,
      };
    case actionTypes.OPEN_INVOICE_CASE_LOADER:
      return {
        ...state,
        openInvoiceCaseLoader: true,
      };

    case actionTypes.GET_INVOICE_DETAILS_SUCCESS:
      return {
        ...state,
        invoiceDetailsData: action.data?.ProjectInfo || action.data || {},
        getInvoiceDetailsLoader: false,
      };
    case actionTypes.GET_INVOICE_DETAILS_FAILURE:
      return {
        ...state,
        invoiceDetailsData: {},
        getInvoiceDetailsLoader: false,
      };
    case actionTypes.GET_INVOICE_DETAILS_LOADER:
      return {
        ...state,
        getInvoiceDetailsLoader: true,
      };

    case actionTypes.VOID_INVOICE_SUCCESS:
      return {
        ...state,
        voidInvoiceLoader: false,
      };
    case actionTypes.VOID_INVOICE_FAILURE:
      return {
        ...state,
        voidInvoiceLoader: false,
      };
    case actionTypes.VOID_INVOICE_LOADER:
      return {
        ...state,
        voidInvoiceLoader: true,
      };

    case actionTypes.RESET_INVOICE_DATA:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
        invoiceCaseDetails: {},
      };

    case actionTypes.RESET_INVOICE_RESOURCE_DATA:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
      };

    case actionTypes.OPEN_PM_CASE_SUCCESS:
      return {
        ...state,
        openPMCaseLoader: false,
        PMCaseData: action?.data?.ProjectInfo || {},
        IsEligibleForAction: action?.data?.IsEligibleForAction === 'true' ? true : false,
        ClientAttachments: action?.data?.ClientAttachments || [],
        Commentslist: action?.data?.Commentslist || [],
        WithdrawReason: action?.data?.WithdrawReason || '',
        holdedResources: action?.data?.ProjectInfo?.HoldedEmployeeList || [],
        reservedResources: action?.data?.ProjectInfo?.ReserveEmployeeList || [],
        allocatedResources: action?.data?.ProjectInfo?.AllocatedEmployeeList || [],
        ResourceNeedCaseInfo: action?.data?.ResourceNeedCaseInfo || {},
        SwapResourceCaseInfo: action?.data?.SwapResourceCaseInfo || {},
        ProjectMaintenanceOptionMenu: action?.data?.ProjectMaintenanceOptionMenu || [],
        RNCaseLoader: false,
      };
    case actionTypes.OPEN_PM_CASE_FAILURE:
      return {
        ...state,
        openPMCaseLoader: false,
        RNCaseLoader: false,
      };
    case actionTypes.OPEN_PM_CASE_LOADER:
      return {
        ...state,
        openPMCaseLoader: true,
      };
    case actionTypes.RESET_PM_DATA_NAV:
      return {
        ...state,
        isProjectSavedSuccessfully: false,
        saveOrCreateProjectData: {},
        isInvoiceSavedSuccessfully: false,
        saveOrCreateInvoiceData: {},
        Commentslist: [],
        PMCaseData: {},
        isCaseWithdrawnSuccessfully: false,
        GoToHome: false,
        ResourceNeedInfo: {},
        WithdrawReason: '',
        holdedResources: [],
        reservedResources: [],
        isClickedOnApply: false,
      };

    case actionTypes.CLEAR_EMP_LIST:
      return {
        ...state,
        ActiveEmployeeList: [],
        isClickedOnApply: false,
      };

    case actionTypes.GET_MY_PROJECTS_SUCCESS:
      return {
        ...state,
        GetMyProjectCasesLoader: false,
        pagination: parseInt(action?.data?.PageIndexCount),
        ProjectCases:
          action?.data?.ProjectCaseList ||
          action?.data?.ManageResourceCaseList ||
          action?.data?.ClientCases ||
          action?.data?.InvoiceCases ||
          [],
      };
    case actionTypes.GET_MY_PROJECTS_FAILURE:
      return {
        ...state,
        GetMyProjectCasesLoader: false,
      };
    case actionTypes.GET_MY_PROJECTS_LOADER:
      return {
        ...state,
        GetMyProjectCasesLoader: true,
      };

    case actionTypes.UPDATE_PM_DATA:
      return {
        ...state,
        PMCaseData: action.data.row || {},
        Commentslist: action.data.Commentslist || [],
      };

    case actionTypes.APPROVE_OR_REJECT_PM_CASE_SUCCESS:
      return {
        ...state,
        ApproveOrRejectPMcaseLoader: false,
      };
    case actionTypes.APPROVE_OR_REJECT_PM_CASE_FAILURE:
      return {
        ...state,
        ApproveOrRejectPMcaseLoader: false,
      };

    case actionTypes.APPROVE_OR_REJECT_PM_CASE_LOADER:
      return {
        ...state,
        ApproveOrRejectPMcaseLoader: true,
      };

    case actionTypes.NEED_RESOURCE_INFO_SUCCESS:
      return {
        ...state,
        CreateResourceInfoLoader: false,
        SkillsList: action.data.SkillsList || [],
        Roleslist: action.data.Roleslist || [],
      };
    case actionTypes.NEED_RESOURCE_INFO_FAILURE:
      return {
        ...state,
        CreateResourceInfoLoader: false,
      };

    case actionTypes.NEED_RESOURCE_INFO_LOADER:
      return {
        ...state,
        CreateResourceInfoLoader: true,
      };

    case actionTypes.CREATE_NEED_RESOURCE_INFO_SUCCESS:
      return {
        ...state,
        GoToHome:
          action?.data?.actionType === 'CreateandClose' ||
          action?.data?.actionType === 'SaveResourceDetails',
        CreateResourceNeedCaseLoader: false,
        ResourceNeedInfo: action?.data,
        PMCaseData:
          action?.data?.actionType === 'Search Resource' ||
          action?.data?.actionType === 'SearchForOtherRoles'
            ? {
                ...state.PMCaseData,
                actionType: action?.data?.ResourceNeedInfo?.actionType || '',
                ReserveDisabledReason:
                  action?.data?.ResourceNeedInfo?.ReserveDisabledReason || '',
                EnableReserve: action?.data?.ResourceNeedInfo?.EnableReserve || '',
              }
            : action?.data?.ResourceNeedInfo || {},
      };
    case actionTypes.CREATE_NEED_RESOURCE_INFO_FAILURE:
      return {
        ...state,
        GoToHome: false,
        CreateResourceNeedCaseLoader: false,
      };

    case actionTypes.CREATE_NEED_RESOURCE_INFO_LOADER:
      return {
        ...state,
        CreateResourceNeedCaseLoader: true,
      };

    case actionTypes.WITHDRAW_PM_CASE_SUCCESS:
      return {
        ...state,
        withdrawCaseLoader: false,
        isCaseWithdrawnSuccessfully: true,
      };
    case actionTypes.WITHDRAW_PM_CASE_FAILURE:
      return {
        ...state,
        withdrawCaseLoader: false,
        isCaseWithdrawnSuccessfully: false,
      };

    case actionTypes.WITHDRAW_PM_CASE_LOADER:
      return {
        ...state,
        withdrawCaseLoader: true,
      };
    case actionTypes.CREATE_NEED_RESOURCE_INFO_LOADER:
      return {
        ...state,
        CreateResourceNeedCaseLoader: true,
      };

    case actionTypes.HOLD_OR_RESERVE_SUCCESS:
      return {
        ...state,
        HoldAndReserveLoader: false,
        holdedResources: action?.data?.HoldedEmployeeList || [],
        reservedResources: action?.data?.ReserveEmployeeList || [],
        allocatedResources: action?.data?.AllocatedEmployeeList || [],
      };
    case actionTypes.HOLD_OR_RESERVE_FAILURE:
      return {
        ...state,
        HoldAndReserveLoader: false,
      };

    case actionTypes.HOLD_OR_RESERVE_LOADER:
      return {
        ...state,
        HoldAndReserveLoader: true,
      };

    case actionTypes.SET_TAB_INDEX_PM:
      return {
        ...state,
        tabIndex: action?.index,
      };

    case actionTypes.SHOW_LOADER_RN_CASE:
      return {
        ...state,
        RNCaseLoader: true,
      };
    case actionTypes.SHOW_RN_CASE_SUCCESS:
      return {
        ...state,
        openPMCaseLoader: false,
        holdedResources: action?.data?.HoldedEmployeeList || [],
        reservedResources: action?.data?.ReserveEmployeeList || [],
        allocatedResources: action?.data?.AllocatedEmployeeList || [],
        RNCaseLoader: false,
      };
    case actionTypes.SHOW_RN_CASE_FAILURE:
      return {
        ...state,
        RNCaseLoader: false,
      };

    case actionTypes.OPEN_SWAP_CASE_TEAMS_SUCCESS:
      return {
        ...state,
        SwapCaseDetailsLoader: false,
        SwapCaseDetails: action.data,
      };
    case actionTypes.OPEN_SWAP_CASE_TEAMS_FAILURE:
      return {
        ...state,
        SwapCaseDetailsLoader: false,
      };
    case actionTypes.OPEN_SWAP_CASE_TEAMS_LOADER:
      return {
        ...state,
        SwapCaseDetailsLoader: true,
      };

    case actionTypes.SEARCH_EMP_PM_SUCCESS:
      return {
        ...state,
        SearchEmpPMLoader: false,
        ActiveEmployeeList: action?.data?.ActiveEmployeeList || [],
      };
    case actionTypes.SEARCH_EMP_PM_FAILURE:
      return {
        ...state,
        SearchEmpPMLoader: false,
      };
    case actionTypes.SEARCH_EMP_PM_LOADER:
      return {
        ...state,
        SearchEmpPMLoader: true,
      };

    case actionTypes.CLOSE_PROJECT_PM_LOADER:
      return {
        ...state,
        closeProjectLoader: true,
      };
    case actionTypes.CLOSE_PROJECT_PM_SUCCESS:
      return {
        ...state,
        closeProjectLoader: false,
        GoToHome: action?.data?.pyNote ? true : false,
      };
    case actionTypes.CLOSE_PROJECT_PM_FAILURE:
      return {
        ...state,
        closeProjectLoader: false,
      };

    case actionTypes.CLICK_APPLY_LOADER:
      return {
        ...state,
        ApplyEndDateLoader: true,
      };
    case actionTypes.CLICK_APPLY_SUCCESS:
      return {
        ...state,
        ApplyEndDateLoader: false,
        isClickedOnApply: true,
        PMCaseData:
          {
            ...state.PMCaseData,
            CurrentAllocation: action?.data?.ProjectInfo?.CurrentAllocation || [],
            UpdatedEndDate: action?.data?.ProjectInfo?.UpdatedEndDate || null,
          } || {},
      };
    case actionTypes.CLICK_APPLY_FAILURE:
      return {
        ...state,
        ApplyEndDateLoader: false,
      };

    case actionTypes.SUBMIT_PROJECT_UPDATE_LOADER:
      return {
        ...state,
        submitProjectUpdateLoader: true,
      };
    case actionTypes.SUBMIT_PROJECT_UPDATE_SUCCESS:
      return {
        ...state,
        submitProjectUpdateLoader: false,
        PMCaseData: action?.data?.pyErrorPage?.pyRawMessage
          ? state.PMCaseData
          : action?.data?.ProjectInfo || {},
        GoToHome: action?.data?.pyNote ? true : false,
      };
    case actionTypes.SUBMIT_PROJECT_UPDATE_FAILURE:
      return {
        ...state,
        submitProjectUpdateLoader: false,
      };

    case actionTypes.CURRENT_PROJECT_ALLOCATION_SUCCESS:
      return {
        ...state,
        allocations: action?.data?.ResourceListBasedOnOperator || [],
        currentProjectAllocationLoader: false,
      };
    case actionTypes.CURRENT_PROJECT_ALLOCATION_FAILURE:
      return {
        ...state,
        currentProjectAllocationLoader: false,
      };

    case actionTypes.CURRENT_PROJECT_ALLOCATION_LOADER:
      return {
        ...state,
        currentProjectAllocationLoader: true,
      };

    case actionTypes.GET_PM_AUDIT_HISTORY_SUCCESS:
      return {
        ...state,
        // ViewProjectAudit/ViewClientAudit/InvoiceAuditHistory return the
        // case data with the rows nested under their own Info wrapper
        // (ProjectInfo.ProjectAuditHistory, ClientInfo.ClientAuditHistory,
        // ProjectInfo.InvoiceAuditHistory) instead of the response itself
        // being the rows array — fall back through each shape so all three
        // still populate from the Project Management flow too.
        auditHistory: Array.isArray(action?.data)
          ? action.data
          : action?.data?.ProjectInfo?.ProjectAuditHistory ||
            action?.data?.ClientInfo?.ClientAuditHistory ||
            action?.data?.ProjectInfo?.InvoiceHistory ||
            [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_PM_AUDIT_HISTORY_FAILURE:
      return {
        ...state,
        auditHistory: [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_PM_AUDIT_HISTORY_LOADER:
      return {
        ...state,
        auditHistoryLoader: true,
      };

    default:
      return state;
  }
}
